import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid
} from '@material-ui/core';

const styles = () => ({
    displayFlex: {
        display: 'flex',
    },
    verticalSpace: {
        margin: '0px 0px 0px 30px',
    },
    clearButtonSpace: {
        margin: '0px 50px 0px 0px',
    },
});

const ResetButton = (props) => {
    const {
        classes,
        setKeyword,
        setAddress,
        setData,
        setIncludeNotPaticipateFlg,
        setIncludeUserInChat
    } = props;

    const clearUserDatas = () => {
        setAddress('');
        setKeyword('');
        setData([]);
        setIncludeNotPaticipateFlg(false);
        setIncludeUserInChat(false);
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.clearButtonSpace} variant="contained" onClick={() => clearUserDatas()}>リセット</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
};

ResetButton.propTypes = {
    setDisplayChatName: PropTypes.func.isRequired,
    setSelectedChatId: PropTypes.func.isRequired,
    setAddress: PropTypes.func.isRequired,
    setKeyword: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
};

export default withStyles(styles)(ResetButton);